/**
 * lib/erreur.ts — le numéro d'une erreur affichée (26/10, Zidan).
 *
 * L'écran d'erreur ne montre plus ni message ni pile : un code de l'app à
 * l'écran, c'est une information donnée à qui n'a pas à l'avoir. Il montre un
 * numéro ; la console (recopiée dans les journaux du serveur de dev) porte le
 * détail avec ce même numéro.
 *
 * Le `digest` de Next quand l'erreur vient du serveur (il est déjà dans ses
 * journaux) ; sinon un numéro stable tiré du message — la même panne donne le
 * même numéro, d'un téléphone à l'autre.
 */
export function referenceErreur(e: Error & { digest?: string }): string {
  if (e.digest) return e.digest;
  let h = 2166136261;
  for (const c of e.message) h = Math.imul(h ^ c.charCodeAt(0), 16777619) >>> 0;
  return h.toString(36).toUpperCase().padStart(6, '0').slice(-6);
}
